import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ErrorBanner/>\n<div id=\"mainContainer\">\n{{outlet}}\n</div>",{ moduleName: "bullitt-time-gochips/templates/application.hbs" })